var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiabetes1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2423_458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 8,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3165 1.87207H3.64648V22.4421H10.3165V1.87207Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2423_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2366 2.62207L5.50659 11.5821C3.85659 14.8221 3.65659 18.9721 7.56659 21.0621C7.56659 21.0621 9.3866 22.0221 11.3566 21.5621",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2423_458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 1,
    width: 7,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9864 1.87207H10.3164V22.4421H16.9864V1.87207Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2423_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3964 2.62207L15.1264 11.5821C16.7764 14.8221 16.9764 18.9721 13.0664 21.0621C13.0664 21.0621 11.2464 22.0221 9.27637 21.5621",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2423_458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 1,
    width: 4,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0065 1.87207H15.1865V10.0321H18.0065V1.87207Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2423_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9865 2.62207L16.3365 5.75207C15.7565 6.88207 15.6865 8.33207 17.0565 9.06207C17.0565 9.06207 17.6865 9.39207 18.3765 9.24207",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2423_458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 1,
    width: 3,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8268 1.87207H18.0068V10.0321H20.8268V1.87207Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2423_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0365 2.62207L19.6865 5.75207C20.2665 6.88207 20.3365 8.33207 18.9665 9.06207C18.9665 9.06207 18.3365 9.39207 17.6465 9.24207",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99606 17.6318V13.1918C9.13606 13.8218 8.55605 14.1418 8.25605 14.1418C8.11605 14.1418 7.98605 14.0918 7.87605 13.9818C7.76605 13.8718 7.70605 13.7418 7.70605 13.6018C7.70605 13.4318 7.75605 13.3118 7.86605 13.2318C7.97605 13.1518 8.16605 13.0518 8.44605 12.9318C8.85605 12.7418 9.18606 12.5518 9.42606 12.3418C9.66606 12.1318 9.88605 11.9118 10.0761 11.6518C10.2661 11.4018 10.3861 11.2418 10.4461 11.1818C10.5061 11.1218 10.6161 11.0918 10.7761 11.0918C10.9561 11.0918 11.0961 11.1618 11.2061 11.2918C11.3161 11.4218 11.3661 11.6118 11.3661 11.8418V17.4318C11.3661 18.0818 11.1361 18.4118 10.6661 18.4118C10.4561 18.4118 10.2961 18.3418 10.1661 18.2118C10.0361 18.0818 9.97606 17.8818 9.97606 17.6218L9.99606 17.6318Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes1);
export default __webpack_public_path__ + "static/media/Diabetes-1.8dbddf6cf71dac020ac6bd76f8c30820.svg";
export { ForwardRef as ReactComponent };